import React from 'react';
import PropTypes from 'prop-types';

// Components
import DropDown from './DropDown';
import SearchBar from './SearchBar';

// Styles
import styles from './styles/Toolbar.scss';

const ToolbarMobile = ({
    onSearch,
    onSelect,
    searchTerm,
    selectOptions,
    showSearch,
    sortBySelection,
}) => {
    return (
        <div className={styles.toolbarMobile}>
            {showSearch && <SearchBar onSearch={onSearch} searchTerm={searchTerm} />}
            <DropDown
                defaultSelection={sortBySelection}
                onSelect={onSelect}
                selectOptions={selectOptions}
                size="large"
                value={sortBySelection}
            />
        </div>
    );
};

ToolbarMobile.propTypes = {
    onSearch: PropTypes.func,
    onSelect: PropTypes.func,
    searchTerm: PropTypes.string,
    selectOptions: PropTypes.array,
    showSearch: PropTypes.bool,
    sortBySelection: PropTypes.string,
};

export default ToolbarMobile;
